import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { breakpoints, isMobile, isTabletDown } from './isMobile';
import { SnapperInstance } from './snapper';

gsap.registerPlugin(ScrollTrigger);

export function EightScene() {

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.seven-section',
            start: 'top top',
            end: '100%',
            scrub: 1,
            invalidateOnRefresh: true
        }
    });
    tl.to('.seven-section__text-block', 1, { y: '-=80vh' });
    tl.to('.seven-section', 1, { autoAlpha: 0 }, '-=0.2');
    tl.to('.eight-section .backgrounds', 1, { autoAlpha: 1 }, '-=1');
    tl.fromTo('.eight-section__text-block h2', 1, { autoAlpha: 0 }, { autoAlpha: 1 }, '-=0.5');
    tl.fromTo('.eight-section__tab', 1, {
        autoAlpha: 0
    }, {
        autoAlpha: 1,
        stagger: {
            each: 0.5,
            ease: 'power1.out',
        }
    }, '-=0.3');
    var currentIndex = 0;
    SnapperInstance.attachLocker(document.querySelector('.eight-section__bg-box'));
    var tabs = document.querySelectorAll('.eight-section__tab');
    var backgrounds = $('.eight-section .backgrounds div');
    var timeline;
    var resizeTimeout;

    var settings = {};
    settings[breakpoints.tabletDown] = function () {
        tabs.forEach((tab, i) => {
            tab.removeEventListener('mouseenter', tab._mouseEnterListener);
        });
        window.removeEventListener('resize', handleResize);
    }
    settings[breakpoints.desktop] = function () {
        tabs.forEach((tab, i) => {
            tab._mouseEnterListener = switchBackground(i);
            tab.addEventListener('mouseenter', tab._mouseEnterListener);
        });
        window.addEventListener('resize', handleResize);
    }
    ScrollTrigger.matchMedia(settings);

    function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            if (currentIndex > 0) {
                var offset = index === 0 ? 0 : $(tabs[currentIndex]).offset().left - $(tabs[0]).offset().left;
                gsap.to('.eight-section__active-tab', .5, { x: offset });
            }
        }, 100);
    }

    function switchBackground(newIndex) {
        return function () {
            console.log(newIndex);
            if (currentIndex !== newIndex) {
                shiftBackground(newIndex);
            }
        }
    }

    function shiftBackground(index) {
        var target = $(tabs[index]);
        var previous = $(tabs[currentIndex]);
        var offset = index === 0 ? 0 : target.offset().left - $(tabs[0]).offset().left;
        if (timeline) {
            timeline.pause();
            gsap
                .to(previous.find('span'), .3, { y: 16, opacity: 0 });
        }
        timeline = gsap.timeline()
            .addLabel('start', timeline ? "+=.15" : "+=0")
            .set(backgrounds[currentIndex], { zIndex: 2 })
            .set(backgrounds[index], { zIndex: 3 })
            .to(backgrounds[index], .5, { opacity: 1 }, "start")
            .to('.eight-section__active-tab', .5, { x: offset }, "start")
            .set(backgrounds[currentIndex], { zIndex: 1, opacity: 0 })
            .fromTo(target.find('span'), .3, { y: 16, opacity: 0 }, { y: 0, opacity: 1 }, '-=.15');
        currentIndex = index;
    }
}